import React, { FunctionComponent } from 'react'

import { Task } from './types'
import Loader from '../../components/loader'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  task: Task
  complete: Callback
  approve: Callback
  reject: Callback
  back: Callback
  isLoading: boolean
}

export const TaskButtons: FunctionComponent<Props> = ({
  task,
  complete,
  approve,
  reject,
  back,
  isLoading = false,
}) => {
  const labelOrLoading = (label: string) => {
    if (!isLoading) return label
    else
      return (
        <div className="loading-button-taks-container">
          <Loader isLoading className="loader--button-tasks-icon" />
        </div>
      )
  }

  switch (task.taskType) {
    case 'CONTACT_LIENHOLDER':
    case 'INSURANCE_POLICY':
    case 'SIGN_LOAN_AGREEMENT':
    case 'UPDATE_LIENHOLDER_INFO':
      return null

    case 'HANDLE_INSUFFICIENT_FUNDS':
    case 'HANDLE_TITLE':
    case 'RECEIVE_APP_FOR_TITLE':
    case 'RECEIVE_LPOA':
    case 'RECEIVE_SPOA':
    case 'SEND_BUYER_PACKET':
    case 'SEND_FUNDS_TO_LIENHOLDER':
    case 'SEND_SPOA_TO_SELLER':
      return (
        <div className="task-modify__buttons--complete-task">
          <button
            onClick={complete}
            data-testid="completeTaskButton"
            className="button button--primary"
            disabled={isLoading}
          >
            {labelOrLoading('Complete')}
          </button>
          <button
            onClick={back}
            data-test="cancelTaskButton"
            className="button button--link-text"
            disabled={isLoading}
          >
            Cancel
          </button>
        </div>
      )

    case 'LOSS_PAYEE':
    case 'REVIEW_USER_DATA_MISMATCH':
      return (
        <div className="task-modify__buttons--approve-task">
          <button
            onClick={approve}
            data-testid="approveTaskButton"
            className="button button--primary"
            disabled={isLoading}
          >
            {labelOrLoading('Approve')}
          </button>
          <button
            onClick={back}
            data-test="cancelTaskButton"
            className="button button--link-text"
            disabled={isLoading}
          >
            Cancel
          </button>
        </div>
      )

    default:
      return (
        <div className="task-modify__buttons--approve-task">
          <button
            onClick={approve}
            data-testid="approveTaskButton"
            className="button button--primary"
            disabled={isLoading}
          >
            {labelOrLoading('Approve')}
          </button>
          <button
            onClick={reject}
            data-testid="rejectTaskButton"
            className="button button--secondary"
            disabled={isLoading}
          >
            {labelOrLoading('Reject')}
          </button>
          <button
            onClick={back}
            data-testid="cancelTaskButton"
            className="button button--link-text"
            disabled={isLoading}
          >
            Cancel
          </button>
        </div>
      )
  }
}

TaskButtons.displayName = 'TaskButtons'
